import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;
  constructor(public route : Router) { }

  ngOnInit() {
  }

  loginUser(form?: NgForm){
    console.log(form.value.id_user);
    this.route.navigate(['career']);
  }

}
